// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__3YNKC","noBorder":"Separator_noBorder__2oqIU","noMargin":"Separator_noMargin__3k602"};